const validateLoginInput = ({ email, password }) => {
	let errors = {};

	if (!email) {
		errors.email = "Email is required.";
	} else if (!/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
		errors.email = "Invalid email format.";
	}

	if (!password) {
		errors.password = "Password is required.";
	} else if (password.length < 6) {
		errors.password = "Password must be at least 6 characters.";
	}

	return errors;
};

export default validateLoginInput;
